import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value"];
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { is, Set as ImmutableSet } from 'immutable';
import { Component } from 'react';
import { formatTypeOption } from 'ui-gdpr-components/utils/subscriptionSelectUtils';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { getSubscriptionDefinitions } from '../api';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const formatSubscriptions = subscriptions => {
  return subscriptions.map(sub => ({
    text: formatTypeOption(sub.process || '', sub.operation || '', sub.name),
    value: sub.id
  }));
};
const filterSubmissions = (subscriptionDefinitions, {
  hideInternal,
  showInactive,
  hideIds,
  customFilter
}) => subscriptionDefinitions.filter(sub => !(hideInternal && sub.internal) && !(!showInactive && !sub.active) && !(hideIds && hideIds.has(sub.id))).filter(customFilter || (() => true));
class LegacySubscriptionTypeSelect extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSelectAllChange = this.onSelectAllChange.bind(this);
    this.getDropdownFooter = this.getDropdownFooter.bind(this);
    this.state = {
      subscriptions: [],
      options: [],
      isLoading: true,
      hideIds: ImmutableSet(props.hideIds || []),
      value: []
    };
  }
  componentDidMount() {
    const {
      hideInternal = false,
      showInactive = false,
      customFilter
    } = this.props;
    const {
      hideIds
    } = this.state;
    getSubscriptionDefinitions().then(subscriptionDefinitions => {
      const subscriptions = filterSubmissions(subscriptionDefinitions, {
        hideInternal,
        showInactive,
        hideIds,
        customFilter
      });
      this.setState({
        subscriptions,
        options: formatSubscriptions(subscriptions),
        isLoading: false
      });
    }).catch(() => {
      throw new Error('Failed to get subscription definition');
    });
  }
  componentDidUpdate() {
    const {
      hideIds: oldHideIds,
      options,
      value
    } = this.state;
    const newHideIds = ImmutableSet(this.props.hideIds || []);
    if (!is(oldHideIds, newHideIds)) {
      const newOptions = options.filter(sub => value.includes(sub.value) || !newHideIds.has(sub.value));
      this.setState({
        options: newOptions,
        hideIds: newHideIds
      });
    }
  }
  getDropdownFooter() {
    const {
      options
    } = this.state;
    const {
      value,
      showSelectAllFooter = false,
      customFooter = null,
      multi
    } = this.props;
    const getHasSelectedValue = () => {
      if (!value) return false;
      return !multi || Array.isArray(value) && value.length > 0;
    };
    const hasSelectedValue = getHasSelectedValue();
    const hasSelectAll = multi && showSelectAllFooter;
    const isSelectAllChecked = hasSelectAll && hasSelectedValue && options.every(option => Array.isArray(value) ? value.includes(option.value) : value === option.value);
    if (customFooter) {
      return customFooter;
    } else if (hasSelectAll) {
      return /*#__PURE__*/_jsx(Checkbox, {
        checked: isSelectAllChecked,
        indeterminate: hasSelectedValue,
        onChange: this.onSelectAllChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "labels.subscriptionTypeSelectAll"
        })
      });
    } else {
      return null;
    }
  }
  onChange({
    target: {
      value
    }
  }) {
    const {
      subscriptions
    } = this.state;
    const {
      onChange,
      multi
    } = this.props;
    const result = [];
    const selectedIds = [].concat(value);
    selectedIds.forEach(id => {
      const selection = subscriptions.filter(sub => sub.id === id)[0];
      if (selection && !selection.process) {
        selection.process = I18n.text('options.marketing');
      }
      if (selection && !selection.operation) {
        selection.operation = I18n.text('options.email');
      }
      result.push(selection);
    });
    this.setState({
      value: selectedIds
    });
    if (onChange) {
      if (multi) {
        onChange(result || []);
      } else {
        onChange(result[0] || null);
      }
    }
  }
  onSelectAllChange({
    target: {
      checked
    }
  }) {
    const {
      options
    } = this.state;
    if (checked) {
      this.onChange(SyntheticEvent(options.map(option => option.value)));
    } else {
      this.onChange(SyntheticEvent([]));
    }
  }
  render() {
    const _this$props = this.props,
      propsWithoutValue = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      options,
      isLoading
    } = this.state;
    return /*#__PURE__*/_jsx(FormControl, Object.assign({
      label: I18n.text('labels.subscriptionType')
    }, this.props.formControlProps, {
      children: /*#__PURE__*/_jsx(Select, Object.assign({
        "data-test-id": "legacy-sub-type-select",
        placeholder: I18n.text('placeholders.subscriptionType')
      }, isLoading ? propsWithoutValue : this.props, {
        options: options,
        isLoading: isLoading,
        onChange: this.onChange,
        "data-selenium-test": "gdpr-sub-type-select",
        dropdownFooter: this.getDropdownFooter()
      }))
    }));
  }
}
export default LegacySubscriptionTypeSelect;